module.exports = __webpack_public_path__ + "static/img/phiendaugiathuongtin.c240bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phiendaugiathuongtin.jpg
// module id = x3sT
// module chunks = 1